import PerformanceReport from '@/api/admin/performanceReport.service'

export default {
  state: {
    table: {
      pageLength: 10,
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      dateFrom: null,
      dateTo: null,
      filterParams: {},
    },
  },
  getters: {
    allPerformanceReport: state => state.table,
    getDateRange: state => ({
      dateFrom: state.table.dateFrom,
      dateTo: state.table.dateTo,
    }),
    getFilterParams: state => ({ filterParams: state.table.filterParams }),
  },
  actions: {
    async getPerformanceReport({ commit, state }) {
      const {
        filterParams,
      } = state.table
      const skip = (state.table.currentPage - 1) * state.table.pageLength
      const filter = {
        skip,
        take: state.table.pageLength,
        dateFrom: state.table.dateFrom,
        dateTo: state.table.dateTo,
        filterParams,
      }

      const performanceReport = await PerformanceReport.getPerformanceReport(filter)
      commit('SET_TOTALRECORDS', performanceReport.totalCount)
      commit('SET_PERFORMANCEREPORT', performanceReport.values)
    },
  },
  mutations: {
    SET_PERFORMANCEREPORT(state, performanceReport) {
      state.table.rows = performanceReport
    },
    SET_TOTALRECORDS(state, totalRecords) {
      state.table.totalRecords = totalRecords
    },
    SET_CURRENT_PAGE_PR(state, newPage) {
      state.table.currentPage = newPage
    },
    SET_DATE_RANGE(state, { dateFrom, dateTo }) {
      state.table.dateFrom = dateFrom
      state.table.dateTo = dateTo
    },
    SET_FILTER_PARAMS(state, filterParams) {
      state.table.filterParams = filterParams
    },
  },
}
